import Button from '@viking-eng/button';
import Footer from '@viking-eng/footer';
import Header from '@viking-eng/header';
import Icon from '@viking-eng/icon';
import PageHeader from '@viking-eng/page-header';
import MvjPropTypes from '@viking-eng/prop-types';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { APP_PAGES } from 'common/Constants';
import getFooterData from 'common/footer-data';
import { getCSAUserAuthData } from 'common/UserStore/UserSelectors';
import PageTabs from 'components/Tabs/PageTabs';
import { hasAnyRole } from 'utils/auth';

const getHeaderData = (roles) => ({
  items: Object.values(APP_PAGES)
    .filter((tab) => hasAnyRole(roles, tab.roles))
    .map((tab) => ({
      ...tab,
      id: tab.path,
      isSmallText: 'false',
      openInNewWindow: 'false',
      url: tab.path,
    })),
  logo: 'https://aem-prod-publish.viking.com/content/dam/vikingcruises/en/magnolia-images/site_elements/viking-white-horiz-logo.svg',
  navigationRoute: '/',
});

const AppLayout = ({ children, firstName, roles }) => {
  const defaultPageTitle = 'CUSTOMER SERVICE';
  const activePath = (window.location.pathname || '/').toLowerCase();
  const pageTabs = Object.values(APP_PAGES).map((tab) => ({
    ...tab,
    enabled: hasAnyRole(roles, tab.roles),
  }));

  const pageTitle = pageTabs.find((t) => t.path === activePath)?.pageTitle || defaultPageTitle;
  return (
    <>
      <Header
        additionalMenus={[
          {
            id: 'rightMenu',
            items: [
              {
                id: 'signOut',
                isSmallText: 'false',
                openInNewWindow: 'false',
                title: 'Sign Out',
                url: '/sign-out',
              },
            ],
          },
        ]}
        header={getHeaderData(roles)}
      >
        <div className="right-menu">
          <Button
            appearance="icon"
            attributes={{
              'aria-expanded': 'false',
              'aria-haspopup': 'true',
              'aria-label': 'Toggle navigation',
              'data-target': '#rightMenu',
              'data-toggle': 'collapse',
              tabIndex: '3',
            }}
            inlineCss={{ color: 'White', fontSize: '16px' }}
          >
            <span className="pr-2 text-uppercase">{`WELCOME, ${firstName}`}</span>
            <Icon name="chevron-down" />
          </Button>
        </div>
      </Header>
      <div className="app-content container">
        <PageHeader hasHomeLink={false} hasPrintLink={false} title={pageTitle} />
        <div className="row">
          <div className="col-12 text-center">
            <PageTabs hideDisabled hideIfSingleTab tabs={pageTabs} />
          </div>
        </div>
        <div>{children}</div>
      </div>
      <Footer {...getFooterData()} />
    </>
  );
};

AppLayout.propTypes = {
  children: MvjPropTypes.jsx.isRequired,
  firstName: PropTypes.string,
  roles: PropTypes.arrayOf(PropTypes.string),
};

AppLayout.defaultProps = {
  firstName: '',
  roles: [],
};

const mapStateToProps = (state) => ({
  firstName: getCSAUserAuthData(state)?.account?.name,
  roles: getCSAUserAuthData(state)?.idTokenClaims?.roles,
});

export default connect(mapStateToProps)(AppLayout);
